module.exports = __webpack_public_path__ + "img/pop.e7b5c844.jpeg";